<template>
  <a-spin tip="Cargando..." :spinning="loading">
    <a-card hoverable>
      <a-card-meta :title="encuesta.short_name"
                   :description="encuesta.description">
        <a-avatar
          slot="avatar"
          src="profileSrc"
        />
      </a-card-meta>
      <template class="ant-card-actions" slot="actions">
        <a-progress style="width: 80%" :strokeColor="{
        '0%': '#108ee9',
        '100%': '#87d068',
      }" :percent="encuesta.fillOut.porcentaje" status="active"
                    v-if="encuesta.fillOut"/>
      </template>
    </a-card>
    <a-row>&nbsp;</a-row>
    <a-collapse>
      <a-collapse-panel v-for="(categoria) in encuesta.active_categories"
                        :header="categoria.short_name"
                        :key="categoria.id">
        <template slot="extra">
          <a-tag style="float: right;" :color="tagColor(categoria)">{{categoria.porcentaje}}%</a-tag>
        </template>

        <a-list :dataSource="categoria.active_questions">
          <a-list-item slot="renderItem" slot-scope="item, index" v-if="!preguntasOcultas.includes(String(item.id))">
            <div style="min-width: 300px;">
              {{item.description}}
            </div>

            <div slot="extra">
              <template v-if="encuesta.active">
                <a-spin tip="Guardando..." :spinning="item.loading === true">
                  <template v-if="item.h_poll_question_type === tipos.T_LOV">
                    <a-select style="min-width: 300px"
                              v-model="item.respuesta"
                              @change="preguntaRespondida(item, categoria)"
                              :showSearch="true"
                              :filterOption="filterOption"
                              :class="{error:item.error}">
                      <a-select-option :value="option.value" v-for="option in item.active_items">
                        {{option.label}}
                      </a-select-option>
                    </a-select>
                  </template>
                  <template v-else-if="item.h_poll_question_type === tipos.T_NUMBER">
                    <a-input-number style="min-width: 300px"
                                    v-model="item.respuesta"
                                    @blur=" preguntaRespondida(item, categoria)"
                                    :class="{error:item.error}"></a-input-number>
                  </template>
                  <template v-else-if="item.h_poll_question_type === tipos.T_DATE">
                    <a-date-picker style="min-width: 300px"
                                   v-model="item.respuesta"
                                   @change="preguntaRespondida(item, categoria)"
                                   :class="{error:item.error}"></a-date-picker>
                  </template>
                  <template v-else="">
                    <a-input style="min-width: 300px"
                             v-model="item.respuesta"
                             @blur=" preguntaRespondida(item, categoria)"
                             :class="{error:item.error}"></a-input>
                  </template>
                </a-spin>
              </template>
              <template v-else>
                <a-alert :message="item.calificacion" type="success"/>
              </template>
            </div>
          </a-list-item>
        </a-list>
      </a-collapse-panel>
    </a-collapse>
  </a-spin>
</template>
<script>
  import JsUtils from '@/util/JsUtils'
  import HttpUtil from '@/util/HttpUtil'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'
  import UserUtil from 'CustomModules/GlobalBPOCore/Util/UserUtil'

  let TIPOS = {
    T_LOV: 'LOV',
    T_TEXT: 'TEXT',
    T_NUMBER: 'NUMBER',
    T_DATE: 'DATE'
  }

  export default {
    data () {
      return {
        encuesta: {},
        error: false,
        loading: false,
        defaultQuestionPicture: require('./../../assets/logoRH2_solo.png'),
        tipos: TIPOS,
        activeKeys: [],
        respuestas: {}, /* TENDRA EL FORMATO: {pregunta_id: respuesta} */
        punterosRespuestas: {}, /* TENDRA EL FORMATO: { question: ref, categoria: ref } */
        preguntasOcultas: []
      }
    },
    props: ['encuesta_id', 'fill_out_id'],
    mounted () {
      this.httpClient = new HttpUtil('encuesta')
      this.cargarEncuesta()
    },
    methods: {
      cargarEncuesta () {
        this.loading = true
        this.error = false
        this.httpClient.getInstance().get('encuesta/' + this.encuesta_id, {
          params: {
            id_poll_fill_out: this.fill_out_id,
            active_only: true
          }
        })
          .then((response) => {
            this.encuesta = response.data
            this.llenarRespuestas()
            this.error = false
          })
          .catch((error) => {
            console.log(error)
            Mensajes.error('Error', 'No fue posible cargar la información de la encuesta.')
            this.error = true
          })
          .then(() => {
            this.loading = false
          })
      },
      preguntaRespondida (pregunta, ctegoria) {
        pregunta.loading = true
        pregunta.error = false
        this.$forceUpdate()
        this.httpClient.getInstance().post('encuestas/fill_out_response', {
          value: pregunta.respuesta,
          id_poll_fill_out: this.fill_out_id,
          id_poll_question: pregunta.id
        }).then((response) => {
          pregunta.error = false
          this.encuesta.fillOut.porcentaje = response.data.porcentaje
          ctegoria.porcentaje = response.data.porcentaje_categoria
          this.respuestas['pregunta_' + pregunta.id] = pregunta.respuesta
          this.evaluarReglas()
        }).catch((error) => {
          Mensajes.error('Error', 'No fue posible guardar la respuesta.')
          pregunta.error = true
        }).then(() => {
          pregunta.loading = false
          this.$forceUpdate()
        })
      },
      filterOption (input, option) {
        return (
          option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
        )
      },
      tagColor (categoria) {
        if (categoria.porcentaje < 50) {
          return 'red'
        }
        if (categoria.porcentaje === 100) {
          return 'green'
        }
        return 'blue'
      },
      llenarRespuestas () {
        this.respuestas = {}
        this.punterosRespuestas = {}
        this.encuesta.active_categories.map(categoria => {
          categoria.active_questions.map(question => {
            this.respuestas['pregunta_' + question.id] = question.respuesta
            this.punterosRespuestas['pregunta_' + question.id] = {
              question: question,
              categoria: categoria
            }
          })
        })
      },
      evaluarReglas () {
        const AND_OPERADOR = 'AND'
        const OR_OPERADOR = 'OR'
        const EQUALS_OPERADOR = 'EQUALS'
        const DIFFERENT_OPERADOR = 'DIFFERENT'
        const UPDTE_ACTION = 'UPDATE'
        const HIDE_ACTION = 'HIDE'
        const SHOW_ACTION = 'SHOW'

        let preguntasOcultas = []
        /* Valida si se cumplen  las condiciones  */
        this.encuesta.active_rules.map(rule => {
          /* Si el operador es AND inicia en true de lo contrario inicia en false */
          let condicionesCumplidas = rule.operador === AND_OPERADOR

          /* Evalua las condiciones */
          for (let i = 0; i < rule.conditions.length; i++) {
            const condition = rule.conditions[i]
            let condicionCumplida = false
            switch (condition.operador) {
              case EQUALS_OPERADOR:
                condicionCumplida = String(this.respuestas['pregunta_' + condition.id_poll_question]) === String(condition.valor)
                break
              case DIFFERENT_OPERADOR:
                condicionCumplida = String(this.respuestas['pregunta_' + condition.id_poll_question]) !== String(condition.valor)
                break
              // TODO IMPLEMENTAR OTRAS CONDICIONES
            }
            if (condicionCumplida) {
              /* Si el operador de regla es AND deben cumplirse todas las condiciones */
              if (rule.operador === AND_OPERADOR) {
                /* como el operador es AND condicionesCumplidas inicia en true */
                continue
              } else {
                /* si el operador es OR con que se cumpla una no hay problema y lo cambiamos a true porque inicia en false */
                condicionesCumplidas = true
                break
              }
            } else {
              if (rule.operador === AND_OPERADOR) {
                /* No se cumplen todas las condiciones */
                condicionesCumplidas = false
                break
              } else {
                /* como es OR simplemente continua hasta que se cumpla la condición */
              }
            }
          }

          /* si se cumplen  las condiciones disparo las acciones */
          rule.actions.map(action => {
            let questions = action.questions.split(',')
            switch (action.accion) {
              case UPDTE_ACTION:
                if (condicionesCumplidas) {
                  questions.map(q => {
                    if (String(this.punterosRespuestas['pregunta_' + q].question.respuesta) !== String(action.valor)) {
                      this.punterosRespuestas['pregunta_' + q].question.respuesta = action.valor
                      this.preguntaRespondida(this.punterosRespuestas['pregunta_' + q].question, this.punterosRespuestas['pregunta_' + q].categoria)
                    }
                  })
                }
                break
              case HIDE_ACTION:
                if (condicionesCumplidas) {
                  questions.map(q => {
                    if (!preguntasOcultas.includes(q)) {
                      preguntasOcultas.push(q)
                    }
                  })
                }
                break
              case SHOW_ACTION:
                if (!condicionesCumplidas) {
                  questions.map(q => {
                    if (!preguntasOcultas.includes(q)) {
                      preguntasOcultas.push(q)
                    }
                  })
                }
                break
            }
          })
        })
        this.preguntasOcultas = preguntasOcultas
      }
    },
    watch: {
      fill_out_id () {
        this.cargarEncuesta()
      }
    }
  }
</script>
<style>
  .error > .ant-select-selection.ant-select-selection--single, .ant-input.error, .ant-calendar-picker.error, .ant-input-number.error {
    border-color: red;
  }
</style>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/components/Encuesta/Encuesta.vue